module.exports = __webpack_public_path__ + "media/images/lb/349-390fa6113ab7523535347a2d9be0ee5d.svg";